import {
  IProductWarehouseHisotryLinkProp,
  IProductWarehouseHisotryLinkCreatePayload
} from 'features/inventory/products/types';
import { BaseService } from 'shared/services/BaseService';

class ProductWarehouseHistoryService extends BaseService<IProductWarehouseHisotryLinkProp> {
  constructor() {
    super('product-warehouse-history');
  }

  // this is a workaround to avoid type errors when calling the add method with a payload that doesn't match the IProductWarehouseHisotryLinkProp interface
  public async add(entity: IProductWarehouseHisotryLinkCreatePayload) {
    return super.add(entity as unknown as IProductWarehouseHisotryLinkProp);
  }

  canDelete = true;
}

export const productWarehouseHistoryService = new ProductWarehouseHistoryService();
